import { createApp } from "vue";
import App from "./App.vue";

import router from "./router";
import store from "./store";

import { registerComponents } from "./componentRegis";
import { registerIcons } from "./iconRegis";
import { registerLibraries } from "./libraryRegis";

import "@/api/config.js";

let app = createApp(App);

app = registerIcons(app);
app = registerComponents(app);
app = registerLibraries(app);

// Custom Styling
import "./stylingRegis.js";

app.use(router);
app.use(store);
app.mount("#app");
